var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconShortcut(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1087_35155)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.8753 4.47058H7.1247C5.65887 4.47058 4.47058 5.65887 4.47058 7.1247V16.8753C4.47058 18.3411 5.65887 19.5294 7.1247 19.5294H16.8753C18.3411 19.5294 19.5294 18.3411 19.5294 16.8753V7.1247C19.5294 5.65887 18.3411 4.47058 16.8753 4.47058Z",
    stroke: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95057 6.83295H7.16234C6.88684 6.83295 6.66351 7.05628 6.66351 7.33177V9.12001C6.66351 9.3955 6.88684 9.61883 7.16234 9.61883H8.95057C9.22606 9.61883 9.4494 9.3955 9.4494 9.12001V7.33177C9.4494 7.05628 9.22606 6.83295 8.95057 6.83295Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8941 6.83295H11.1059C10.8304 6.83295 10.6071 7.05628 10.6071 7.33177V9.12001C10.6071 9.3955 10.8304 9.61883 11.1059 9.61883H12.8941C13.1696 9.61883 13.3929 9.3955 13.3929 9.12001V7.33177C13.3929 7.05628 13.1696 6.83295 12.8941 6.83295Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.8377 6.83295H15.0494C14.7739 6.83295 14.5506 7.05628 14.5506 7.33177V9.12001C14.5506 9.3955 14.7739 9.61883 15.0494 9.61883H16.8377C17.1131 9.61883 17.3365 9.3955 17.3365 9.12001V7.33177C17.3365 7.05628 17.1131 6.83295 16.8377 6.83295Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.95057 10.8329H7.16234C6.88684 10.8329 6.66351 11.0563 6.66351 11.3318V13.12C6.66351 13.3955 6.88684 13.6188 7.16234 13.6188H8.95057C9.22606 13.6188 9.4494 13.3955 9.4494 13.12V11.3318C9.4494 11.0563 9.22606 10.8329 8.95057 10.8329Z",
    fill: "#3C3C3C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.8941 10.8329H11.1059C10.8304 10.8329 10.6071 11.0563 10.6071 11.3318V13.12C10.6071 13.3955 10.8304 13.6188 11.1059 13.6188H12.8941C13.1696 13.6188 13.3929 13.3955 13.3929 13.12V11.3318C13.3929 11.0563 13.1696 10.8329 12.8941 10.8329Z",
    fill: "#3C3C3C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1087_35155"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(4 4)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconShortcut);
export default __webpack_public_path__ + "static/media/icon_shortcut.6a2aa6b1a717fcbcd81f2a3389a9c690.svg";
export { ForwardRef as ReactComponent };